import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const DirectoryHomePage = lazy(() => import('@/modules/directory/pages/DirectoryHomePage'));
const DirectoryMembersPage = lazy(() => import('@/modules/directory/pages/DirectoryMembersPage'));
const DirectoryFamiliesPage = lazy(() => import('@/modules/directory/pages/DirectoryFamiliesPage'));
const DirectoryGroupsPage = lazy(() => import('@/modules/directory/pages/DirectoryGroupsPage'));
const DirectoryBirthdaysPage = lazy(() => import('@/modules/directory/pages/DirectoryBirthdaysPage'));
const DirectoryAnniversariesPage = lazy(() => import('@/modules/directory/pages/DirectoryAnniversariesPage'));
const DirectoryPrintPage = lazy(() => import('@/modules/directory/pages/DirectoryPrintPage'));
const AdminDirectorySettingsPage = lazy(() => import('@/modules/directory/pages/AdminDirectorySettingsPage'));
const AdminChangeRequestsPage = lazy(() => import('@/modules/directory/pages/AdminChangeRequestsPage'));
const MemberProfilePage = lazy(() => import('@/modules/directory/pages/MemberProfilePage'));
const DirectoryMemberDetailsPage = lazy(() => import('@/modules/directory/pages/DirectoryMemberDetailsPage'));

const DirectoryWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={
    <div className="flex items-center justify-center min-h-96">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
    </div>
  }>
    {children}
  </Suspense>
);

export const directoryRoutes: RouteObject[] = [
  { path: '/directory', element: <DirectoryWrapper><DirectoryHomePage /></DirectoryWrapper> },
  { path: '/directory/members', element: <DirectoryWrapper><DirectoryMembersPage /></DirectoryWrapper> },
  { path: '/directory/member/:id', element: <DirectoryWrapper><DirectoryMemberDetailsPage /></DirectoryWrapper> },
  { path: '/directory/families', element: <DirectoryWrapper><DirectoryFamiliesPage /></DirectoryWrapper> },
  { path: '/directory/groups', element: <DirectoryWrapper><DirectoryGroupsPage /></DirectoryWrapper> },
  { path: '/directory/birthdays', element: <DirectoryWrapper><DirectoryBirthdaysPage /></DirectoryWrapper> },
  { path: '/directory/anniversaries', element: <DirectoryWrapper><DirectoryAnniversariesPage /></DirectoryWrapper> },
  { path: '/directory/print', element: <DirectoryWrapper><DirectoryPrintPage /></DirectoryWrapper> },
  { path: '/directory/settings', element: <DirectoryWrapper><AdminDirectorySettingsPage /></DirectoryWrapper> },
  { path: '/directory/change-requests', element: <DirectoryWrapper><AdminChangeRequestsPage /></DirectoryWrapper> },
  { path: '/directory/my-profile', element: <DirectoryWrapper><MemberProfilePage /></DirectoryWrapper> },
];